<template>
    <div class="navbar has-color-initial" :class="{active: isActive}">
        <div class="title">
            <router-link to="/">
            <h2>Lewis County</h2>
            <h4>Waste Widget</h4>
            </router-link>
        </div>

        <transition name="fade" appear>
            <div class="menu-background" v-on:click="isActive = !isActive" v-if="isActive"></div>
        </transition>
        <div class="menu-wrap" >
            <ul class="menu inline">
                <li v-for="mi in menu" v-bind:key="mi.title">
                    <router-link v-if="mi.internal" :to="mi.url">{{ mi.title }}</router-link>
                    <a v-else v-bind:href="mi.url">{{ mi.title }}</a>
                </li>
            </ul>
        </div>
        <div class="mobile-menu" >
            <ul class="menu inline">
                <li v-for="mi in menu" v-bind:key="mi.title" v-on:click="isActive= !isActive">
                    <router-link v-if="mi.internal" :to="mi.url">{{ mi.title }}</router-link>
                    <a v-else v-bind:href="mi.url">{{ mi.title }}</a>
                </li>
            </ul>
        </div>
        <div class="social-wrap">
            <div class="hamburger" v-on:click="isActive = !isActive" :class="{active: isActive}">
                <div class="line one"></div>
                <div class="line two"></div>
                <div class="line three"></div>
            </div>
            <div class="social">
                <a href="https://www.facebook.com/LewisCountySolidWaste" target="_blank" rel="noopener noreferrer"><i class="fab fa-facebook-f" title="facebook"></i></a>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
export default {
    name: "topmenu",
    data() {
        return {
            title: null,
            menu: [],
            isActive: false,
        }
    },
    created() {
        this.fetchHomeTitle().then(data => {
            this.title = data.title;
        })
        this.fetchMenuData().then(data => {
            this.menu = data;
        });
    },
    methods: {
        fetchMenuData() {
            return axios.get('/api/get_top_menu/').then(response => {
                return response.data;
            });
        },
        fetchHomeTitle() {
            return axios.get('/api/get_home_title').then(response => {
                return response.data;
            })
        }
    },
    computed: {
        // backgroundClick(){
        //     if 
        // }
    }
}
</script>

<style lang="sass" scoped>

    .hamburger
        display: block
        cursor: pointer
        margin-right: 2rem

        .line
            width: 28px
            height: 2px
            margin-bottom: 6px
            background: #333333

    .social-wrap
        display: flex
        position: relative
        z-index: 1

        i
            font-size: 2rem

    .title
        h4 
            margin-bottom: 0
    
    .active
        .social-wrap
            z-index: 2

    .fade-enter-active, .fade-leave-active 
        transition: opacity .5s
    
    .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ 
        opacity: 0
    
    @media (min-width: 769px)
        .hamburger
            display: none

        .menu
            a 
                font-size: 1.65rem

</style>